"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputButton = _interopRequireDefault(require("../Button/InputButton"));

var _DurationInput = require("./DurationInput.style");

var DurationInput =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DurationInput, _Component);

  function DurationInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DurationInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DurationInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onButtonClick", function (e) {
      _this.props.onButtonClick && _this.props.onButtonClick(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onInputBlur", function (type) {
      return function (e) {
        var value = _this.props.value;
        var minutes = value.split(':')[0];
        var seconds = value.split(':')[1];
        var duration = ['', ''];
        var parsedValue = parseInt(e.target.value, 10);

        if (parsedValue !== 0 && !parsedValue) {
          return;
        }

        if (parsedValue < 0) {
          return;
        }

        if (parsedValue > 59 && type === 'seconds') {
          parsedValue = 59;
        }

        if (parseInt(seconds, 10) > 59) {
          seconds = '59';
        }

        if (type === 'minutes') {
          duration[0] = parsedValue;
          duration[1] = seconds;
        } else {
          duration[0] = minutes;
          duration[1] = parsedValue;
        }

        _this.props.onInputBlur && _this.props.onInputBlur(e, duration.join(':'));
      };
    });
    return _this;
  }

  (0, _createClass2.default)(DurationInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          value = _this$props.value,
          className = _this$props.className;

      var _value$split$map = value.split(':').map(function (time) {
        return parseInt(time, 10).toString();
      }),
          _value$split$map2 = (0, _slicedToArray2.default)(_value$split$map, 2),
          minutes = _value$split$map2[0],
          seconds = _value$split$map2[1];

      return _react.default.createElement(_DurationInput.StyledDiv, {
        className: className
      }, _react.default.createElement(_DurationInput.StyledInputWrapper, {
        isMinute: true
      }, _react.default.createElement(_InputButton.default, {
        buttonProps: {
          text: "".concat(minutes, " m"),
          style: {
            lineHeight: '28px',
            padding: '6px 0'
          },
          disabled: disabled
        },
        inputProps: {
          defaultValue: minutes,
          maxLength: 3,
          textAlign: 'right'
        },
        onButtonClick: this.onButtonClick,
        onInputBlur: this.onInputBlur('minutes')
      })), _react.default.createElement(_DurationInput.StyledInputWrapper, null, _react.default.createElement(_InputButton.default, {
        buttonProps: {
          text: "".concat(seconds, " s"),
          style: {
            lineHeight: '28px',
            padding: '6px 0'
          },
          disabled: disabled
        },
        inputProps: {
          defaultValue: seconds,
          maxLength: 2,
          textAlign: 'right'
        },
        onButtonClick: this.onButtonClick,
        onInputBlur: this.onInputBlur('seconds')
      })));
    }
  }]);
  return DurationInput;
}(_react.Component);

DurationInput.propTypes = {
  value: _propTypes.default.string,
  onInputBlur: _propTypes.default.func,
  disabled: _propTypes.default.bool
};
DurationInput.defaultProps = {
  value: '',
  onInputBlur: function onInputBlur() {},
  disabled: false
};
var _default = DurationInput;
exports.default = _default;